<!-- 合作伙伴主数据 -->
<template>
  <div class="cooperation">
    <!-- “cooperation”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    ></sirui-search>
    <!-- container -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        rowKey="id"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'partnerType'">{{
              partnerTypeData[scope.row[item.field]]
            }}</span>
            <span v-else-if="item.field === 'requestStatus'">{{
              requestStatusData[scope.row[item.field]]
            }}</span>
            <span v-else-if="item.type === 'seq'">{{ scope.row['rowNo'] }}</span>
            <span v-else-if="item.field === 'ifPersonalPartner'">
              <template v-if="scope.row[item.field] == 1">是</template>
              <template v-if="scope.row[item.field] == 0">否</template>
            </span>
            <span v-else-if="item.field === 'ifCreditPartner'">
              <template v-if="scope.row[item.field] == 1">是</template>
              <template v-if="scope.row[item.field] == 0">否</template>
            </span>
            <span v-else-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.field == 'auditReason'">
              {{ scope.row.requestStatus == 'ZT05' ? scope.row[item.field] : '' }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- <el-upload
      style="display: none"
      ref="import"
      :data="importData"
      :action="importUrl"
      accept=".xls, .xlsx"
      :before-upload="uploadBefore"
      :on-success="uploadSuccess"
      :show-file-list="true"
      :with-credentials="true"
      :on-error="uploadError"
    >
      <el-button ref="importBtn"></el-button>
    </el-upload> -->
    <SiruiUpload
      @getData="getData"
      ref="SiruiUpload"
      :action="importUrl"
      :data="importData"
      :isShowDownTemplateBtn="true"
    ></SiruiUpload>
    <!-- 扩展申请弹窗 -->
    <expand
      ref="expand"
      :forbidden="this.forbidden"
      :sellForbid="this.sellForbid"
      :purchaseForbid="this.purchaseForbid"
      :subjectProcureList="this.subjectProcureList"
      :subjectList="this.subjectList"
      :purchaseSubjectRule="this.purchaseSubjectRule"
      :sellSubjectRule="this.sellSubjectRule"
      @resolveSellRules="resolveSellRules"
    />
    <check ref="check" />
    <merge ref="merge" @refreshData="refreshData" />
    <reject ref="reject" @handleSure="handleSure" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import SiruiUpload from '@/components/SiruiUpload';

  import Check from './dialog/check'; // 查重弹窗
  import Reject from './dialog/reject'; // 审批弹窗
  import Expand from './dialog/expand';
  import Merge from './dialog/merge'; // 合并弹窗
  import API from '@/api/masterData/cooperation';
  import BASE_API from '@/api/dataBase';
  import { sellSubjectRule, purchaseSubjectRule } from './rules/rules';
  import XEUtils from 'xe-utils';
  // import baseUrl from '@/common/config';
  export default {
    name: 'cooperation',
    components: {
      SiruiSearch,
      SiruiTable,
      SiruiUpload,
      Check,
      Merge,
      Reject,
      Expand,
    },
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        let searchColumns = [
          {
            // 合作伙伴名称
            prop: 'partnerZhName',
            name: '合作伙伴名称',
            type: 'input',
          },
          {
            // 合作伙伴名称
            prop: 'abbreviation',
            name: '合作伙伴简称',
            type: 'input',
          },
          {
            prop: 'creditCode',
            name: '统一社会信用代码',
            type: 'input',
          },
          {
            // 合作伙伴类型
            prop: 'partnerType',
            name: '合作伙伴类型',
            type: 'dict',
            dictType: 'partner_type',
          },
          {
            // 合作伙伴编码
            prop: 'partnerCode',
            name: '合作伙伴编码',
            type: 'input',
          },
          {
            name: '创建人',
            prop: 'createBy',
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            name: '业务负责人',
            prop: 'businessPersonNo',
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            name: '身份识别证件编号',
            prop: 'identityNo',
            type: 'input',
          },
          {
            name: '授信合作伙伴',
            prop: 'ifCreditPartner',
            type: 'dict',
            dictType: 'yes-no',
          },
          {
            name: '国家',
            prop: 'isDomestic',
            type: 'dict',
            dictType: 'person_national',
          },
          {
            name: '省',
            prop: 'province',
            type: 'ajaxSelect',
            apiUrl: BASE_API.QUERY_PROVICE + '?parentAreaNo=' + this.query.isDomestic,
            apiData: {},
          },
          {
            name: '市',
            prop: 'city',
            type: 'ajaxSelect',
            apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + this.query.province,
            apiData: {},
          },
          {
            name: '审核状态',
            prop: 'requestStatus',
            type: 'select',
            options: this.requestStatusList,
          },
          {
            name: '个人合作伙伴',
            prop: 'ifPersonalPartner',
            type: 'dict',
            dictType: 'yes-no',
          },

          {
            // 申请日期从
            name: '申请日期从',
            prop: 'startTime',
            type: 'startDaterangePicker',
          },
          {
            // 申请日期到
            name: '至',
            prop: 'endTime',
            type: 'endDaterangePicker',
          },
          {
            name: '选择视图',
            prop: 'selectView',
            type: 'select',
            options: this.selectViewList,
          },
          // {
          //   // 搜索简码
          //   prop: 'searchCode',
          //   name: this.$t('cooperation.label.searchCode'),
          //   type: 'inputIcon',
          // },
          // {
          //   name: '申请人',
          //   prop: 'requestBy',
          //   type: 'searchTableSpec',
          //   searchType: 'personnel',
          //   isMultiple: true,
          // },
          /* {
        name: "最大命中数",
        prop: "maxNumberOfHits",
        type: "inputAmount",
        precision: 0,
      }, */
        ];
        let obj = {
          name: '部门',
          prop: 'departmentCodes',
          type: 'treeSelect',
          apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
          apiData: {
            tenantCode: this.userInfo.tenantCode,
            adminFlag: this.userInfo.adminFlag,
            selfCompanyDepartmentTreeFlag: true,
          },
          span: 12,
          multiple: true,
        };
        if (this.query.selectView != '00') searchColumns.push(obj);
        return searchColumns;
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),
    },
    watch: {
      'query.selectView': {
        handler(newName) {
          if (newName == '00') this.query.departmentCodes = '';
        },
      },
    },
    created() {
      this.getDictList(); // 在mounted中无效，提前加载
    },
    activated() {
      this.getData();
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.setImport();
    },
    data() {
      return {
        load: false,
        query: {
          partnerZhName: '',
          partnerCode: '',
          //合作伙伴简称
          abbreviation: '',
          //业务负责人
          businessPersonNo: '',
          createBy: '',
          startTime: '',
          endTime: '',
          partnerType: '',
          // searchCode: '',
          requestStatus: '',
          selectView: '00',
          departmentCodes: '',
          creditCode: '',
          identityNo: '',
          ifPersonalPartner: '',
          ifCreditPartner: '',
          requestBy: '',
          isDomestic: '',
          province: '',
          city: '',
          maxNumberOfHits: 200, //最大命中数
        },
        forbidden: true, // 是否禁用
        sellForbid: true,
        purchaseForbid: true,
        sellSubjectRule: [], // 销售数据对账科目校验规则
        purchaseSubjectRule: [], // 采购数据对账科目校验规则
        subjectList: [], // 对账科目销售
        subjectProcureList: [], //采购
        idList: [],
        reason: null,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        partnerTypeData: {}, // 合作伙伴类型 => 用于表格回显
        requestStatusData: {}, // 状态 => 用于表格回显
        partnerTypeList: [], // 合作伙伴类型下拉
        departmentList: [], //部门列表
        selectViewList: [
          {
            value: '00',
            label: '基本视图',
          },
          {
            value: '01',
            label: '扩展视图',
          },
        ], //视图下拉
        requestStatusList: [], // 状态下拉
        importUrl: '',
        importData: {},
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            type: 'seq',
            title: 'table.index',
            visible: true,
            width: '80',
          },
          {
            field: 'partnerType',
            title: 'cooperation.label.partnerType',
            visible: true,
          },
          {
            field: 'partnerZhName',
            title: 'cooperation.label.partnerZhName',
            visible: true,
          },
          {
            field: 'requestStatus',
            title: 'cooperation.label.requestStatus',
            visible: true,
          },
          {
            field: 'partnerCode',
            title: 'cooperation.label.partnerCode',
            visible: true,
          },
          // {
          //   field: "identityNo",
          //   title: "cooperation.label.identityNo",
          //   visible: true
          // },
          {
            field: 'creditCode',
            title: 'cooperation.label.creditCode',
            visible: true,
          },
          // {
          //   field: 'creditLimitAmount',
          //   title: 'cooperation.label.creditLimitAmount',
          //   visible: true,
          // },
          {
            field: 'requestByName',
            title: '创建人',
            visible: true,
          },
          {
            field: 'departmentName',
            title: '所属部门',
            visible: true,
          },
          {
            field: 'requestTime',
            title: 'cooperation.label.requestTime',
            visible: true,
          },
          {
            field: 'ifDomestic',
            title: '国家',
            visible: true,
            dictType: 'person_national',
          },
          {
            field: 'contactPersonName',
            title: '联系人',
            visible: true,
          },
          {
            field: 'mobilePhone',
            title: '联系电话',
            visible: true,
          },
          {
            field: 'ifPersonalPartner',
            title: '个人合作伙伴',
            visible: true,
            dictType: 'yes-no',
          },
          {
            field: 'ifCreditPartner',
            title: '授信合作伙伴',
            visible: true,
            dictType: 'yes-no',
          },
          {
            field: 'identityNo',
            title: '身份识别证件编号',
            visible: true,
          },
          {
            field: 'auditReason',
            title: '驳回原因',
            visible: true,
          },
        ],
      };
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          console.log(res, '1111');
          this.columnList = this.columnListDefault;
          this.columnList.forEach(function (element) {
            if (element.field == 'ifPersonalPartner') {
              element.dictType = 'yes-no';
            }
            if (element.field == 'ifCreditPartner') {
              element.dictType = 'yes-no';
            }
            if (element.field == 'ifDomestic') {
              element.type = 'dict';
              element.dictType = 'person_national';
            }
          });
        });
      },
      // 获取字典表数据
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 获取部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          }
        });
        // 合作伙伴类型
        this.$axios.post(API.DICT_LIST, { dictType: 'partner_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.partnerTypeList = res.data.data; // 下拉
            for (var item of res.data.data) {
              // => 用于表格回显
              this.partnerTypeData[item['value']] = item['label'];
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
        // 状态
        this.$axios.post(API.DICT_LIST, { dictType: 'request_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.requestStatusList = res.data.data; // 下拉
            for (var item of res.data.data) {
              // => 用于表格回显
              this.requestStatusData[item['value']] = item['label'];
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
        //销售数据对帐
        this.$axios
          .post(API.DICT_LIST, { dictType: 'generalLedgerAccountSales', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.subjectList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //采购数据对账
        this.$axios
          .post(API.DICT_LIST, { dictType: 'generalLedgerAccountPurchase', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.subjectProcureList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 根据合作伙伴类型判断销售、采购的检验状态
      resolveSellRules(value) {
        if (value === 'HZHB01' || value === 'HZHB10') {
          // 客户
          this.sellSubjectRule = sellSubjectRule;
          this.sellForbid = false;
          this.purchaseSubjectRule = [];
          this.purchaseForbid = true;
          // this.$refs.purchasingData.resetFields();
        }
        // else if (value === "HZHB02") { // 供应商
        //   this.sellSubjectRule = [];
        //   this.sellForbid = true;
        //   this.$refs.salesData.resetFields();
        //   this.purchaseSubjectRule = purchaseSubjectRule;
        //   this.purchaseForbid = false;
        // }
        else if (value === 'HZHB03') {
          // 合作伙伴
          this.sellSubjectRule = sellSubjectRule;
          this.sellForbid = false;
          this.purchaseSubjectRule = purchaseSubjectRule;
          this.purchaseForbid = false;
        } else {
          // 其他
          // this.sellSubjectRule = sellSubjectRule;
          // this.purchaseSubjectRule = [];
          // this.sellForbid = false;
          // this.purchaseForbid = false;
          this.sellSubjectRule = [];
          this.sellForbid = true;
          // this.$refs.salesData.resetFields();
          this.purchaseSubjectRule = purchaseSubjectRule;
          this.purchaseForbid = false;
        }
      },
      getData(search) {
        // this.$refs.siruiTable.clearCheckboxReserve();
        if (search) {
          let count = Object.keys(this.query).length;
          for (var key in this.$refs.siruiSearch.query) {
            if (
              this.$refs.siruiSearch.query[key] == null ||
              this.$refs.siruiSearch.query[key] == undefined ||
              this.$refs.siruiSearch.query[key] == []
            ) {
              count--;
            }
          }
          if (count == 0) {
            this.$message({
              showClose: true,
              message: this.$t('search.nosearchError'),
              type: 'error',
            });
            return;
          }
        }
        this.load = true;
        let params = JSON.parse(JSON.stringify(this.query));
        params.partnerString = [];
        if (params.partnerCode) {
          params.partnerString.push(params.partnerCode);
        }
        params.partnerString = JSON.stringify(params.partnerString);
        if (params.businessPersonNo && params.businessPersonNo.length != 0) {
          params.businessPersonNo = params.businessPersonNo ? params.businessPersonNo[0].id : null;
        }
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.adminFlag = this.userInfo.adminFlag;
        params.departmentCodes = params.departmentCodes ? params.departmentCodes : null;
        params.departmentCodeList = null;
        if (this.userInfo.adminFlag == '1') {
          //公司权限 查询所有的  不传表示有公司权限
          params.selectAllPartner = 'Y';
        } else {
          params.selectAllPartner = 'N';
        }
        // params.departmentCode = this.userInfo.departmentCode;
        console.log('search query', params.requestBy);
        //申请人
        // params.createBy = this.userInfo.userCode;
        params.requestBy = XEUtils.isArray(params.requestBy) ? params.requestBy[0].id : '';
        params.createBy = XEUtils.isArray(params.createBy) ? params.createBy[0].id : '';
        this.$axios.post(API.LIST_PARTNER, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list.map((item, index) => {
              return {
                ...item,
                rowNo: index + 1,
              };
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      chooseClick(type) {
        console.log(type);
        console.log(this.multipleSelection, '选中合作伙伴的');
        if (type === 'edit') {
          if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: false,
              type: 'warning',
              message: '您只能选择一条数据进行编辑',
            });
          } else if (this.multipleSelection.length === 1) {
            let row = this.multipleSelection[0];
            console.log(row);
            let path = {
              path: '/masterData/editCooperation',
              name: 'editCooperation',
              meta: {
                keepAlive: false,
                title: this.$t('cooperation.route.editCooperation'),
              },
              query: {
                id: row.id,
                partnerCode: row.partnerCode,
                partnerZhName: row.partnerZhName,
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          } else {
            this.$message({ showClose: false, type: 'warning', message: '您还没有选择数据' });
          }
        } else if (type == 'add') {
          let path = {
            path: '/masterData/addCooperation',
            name: 'addCooperation',
            meta: {
              keepAlive: true,
              title: this.$t('cooperation.addCooperation'),
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'export') {
          this.handleExport();
        } else if (type === 'import') {
          this.handleImport();
        } else if (type === 'forbid') {
          this.handleForbid('ZT04');
        } else if (type === 'enable') {
          this.handleEnable('ZT03');
        } else if (type === 'check') {
          this.handleCheck();
        } else if (type === 'merge') {
          this.handleMerge();
        } else if (type === 'reject') {
          this.handleRejectValue = 'ZT05';
          this.sureOpenReject(2);
        } else if (type === 'approval') {
          this.handleRejectValue = 'ZT03';
          this.sureOpenReject(1);
        } else if (type === 'expand') {
          this.expand();
        } else if (type === 'syncMDG') {
          if (this.query.selectView == '00') {
            this.syncMDG();
          }
        } else if (type == 'supplementImport') {
          this.importUrl = API.SUPPLEMENT_IMPORT_PARTNER;
          this.$refs.SiruiUpload.openDialog(true, '106');
        }
      },
      //同步mdg
      syncMDG() {
        // 可多选
        let partnerCodes = [];
        for (let item of this.multipleSelection) {
          partnerCodes.push(item.partnerCode);
        }
        this.loading.startLoading();
        this.$axios.post(API.PARTNER_SYNCMDG, partnerCodes).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$refs.siruiTable.clearCheckboxReserve();
            this.idList = [];
            this.getData();
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 扩展按钮点击事件
      expand() {
        if (this.multipleSelection.length !== 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
          return;
        }
        let flag = this.multipleSelection.findIndex((item) => item.requestStatus == 'ZT03');
        if (flag == -1) {
          this.$message({
            showClose: true,
            message: '只有已生效的才可以扩展！',
            type: 'error',
          });
          return;
        }
        let companyInfo = {
          companyName: this.userInfo.companyName || '',
          companyCode: this.userInfo.companyCode || '',
          departmentName: this.multipleSelection[0].departmentName || '',
          departmentCode: this.multipleSelection[0].departmentCode || '',
        };
        // console.log(companyInfo);
        this.$refs.expand.openDialog(
          this.multipleSelection[0],
          this.partnerTypeList,
          '',
          this.departmentList,
          companyInfo
        );
      },
      sureOpenReject(type) {
        if (this.resolveSelected('more')) {
          let isRequestStatus = this.multipleSelection.every(
            (item) => item.requestStatus == 'ZT02'
          );
          this.multipleSelection.forEach((item) => {
            if (item.requestStatus == 'ZT02') {
              this.idList.push(item.id);
            }
          });
          if (isRequestStatus) {
            this.$refs.reject.openDialog(this.handleRejectValue, type);
          } else {
            this.$message({
              showClose: true,
              message: this.$t('cooperation.placeholder.pleaseChangeOne'),
              type: 'error',
            });
          }
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.pleaseSelectOne'),
            type: 'error',
          });
          return false;
        }
        return true;
      },
      // 导出
      handleExport() {
        let params = {};
        let tableColumn = this.$refs.siruiTable.getTableColumn().tableColumn;
        let showColumns = [];
        tableColumn.forEach((item) => {
          if (item.property) {
            if (item.property === 'partnerType' || item.property === 'requestStatus') {
              showColumns.push({ prop: `${item.property}Name`, label: item.title });
            } else {
              showColumns.push({ prop: item.property, label: item.title });
            }
          }
        });
        if (this.multipleSelection.length !== 0) {
          params.list = this.multipleSelection.map((item) => {
            return item.id;
          });
        } else {
          const { startTime, endTime, partnerType, requestStatus } = this.query;
          params = { startTime, endTime, partnerType, requestStatus };
          params.adminFlag = this.userInfo.adminFlag;
          // params.createBy = this.userInfo.userCode;
          // params.departmentCode = this.userInfo.departmentCode;
        }
        params.columns = JSON.stringify(showColumns);
        this.loading.startLoading();
        this.$axios.post(API.EXPORT_PARTNER_SELECT_COLUMN, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/masterData/editCooperation',
          name: 'editCooperation',
          meta: {
            keepAlive: false,
            title: '合作伙伴详情',
          },
          query: {
            id: value.row.id,
            partnerCode: value.row.partnerCode,
            partnerZhName: value.row.partnerZhName,
            departmentCode: value.row.departmentCode,
          },
        };
        if (value.row.requestStatus == 'ZT02' && this.userInfo.businessGroup == '物贸') {
          console.log(
            '审批中',
            value.row.requestStatus == 'ZT02',
            this.userInfo.businessGroup == '物贸'
          );
          path.query.from = 'todo';
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表格选择行
      handleSelectionChange(rows) {
        console.log('勾选逻辑', rows);
        this.multipleSelection = rows;
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getData(true);
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getData();
      },
      // 启用
      handleEnable(type) {
        if (this.resolveSelected('more')) {
          // 可多选
          let partnerCodeList = [];
          for (let item of this.multipleSelection) {
            if (item.requestStatus === 'ZT04') {
              let { departmentCode, partnerCode } = item;
              let obj = { departmentCode, partnerCode };
              partnerCodeList.push(obj);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('cooperation.message.enable_to_forbid'),
                type: 'error',
              });
              return false;
            }
          }
          let params = {
            requestStatus: type,
            partnerString: JSON.stringify(partnerCodeList),
          };
          this.$axios.post(API.UPDATE_IS_PARTNERS, params).then((res) => {
            if (res.data.code === 0) {
              this.$refs.siruiTable.clearCheckboxReserve();
              this.idList = [];
              this.getData();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      // 禁用
      handleForbid(type) {
        if (this.resolveSelected('more')) {
          // 可多选
          let partnerCodeList = [];
          for (let item of this.multipleSelection) {
            if (item.requestStatus === 'ZT03') {
              let { departmentCode, partnerCode, partnerType } = item;
              let obj = { departmentCode, partnerCode, partnerType };
              partnerCodeList.push(obj);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('cooperation.message.forbid_to_enable'),
                type: 'error',
              });
              return false;
            }
          }
          let params = {
            requestStatus: type,
            partnerString: JSON.stringify(partnerCodeList),
          };
          this.$axios.post(API.UPDATE_IS_PARTNERS, params).then((res) => {
            if (res.data.code === 0) {
              this.$refs.siruiTable.clearCheckboxReserve();
              this.idList = [];
              this.getData();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      handleSure(val, type) {
        this.handleReject(this.handleRejectValue, this.idList, val, type);
      },
      //驳回（2）,审批（1）
      handleReject(val, idList, reason, type) {
        let tempList = [];
        console.log('oldIdList', idList);
        // 可多选
        if (val) {
          this.multipleSelection.forEach((item) => {
            if (item.requestStatus == 'ZT02') {
              tempList.push({ extendId: item.id, type, auditReason: reason });
            }
          });
          // let params = {
          //   ids: tempList,
          //   requestStatus: val,
          //   auditReason: reason,
          // };
          this.$axios.post(API.UPDATE_IS_REJECT, tempList).then((res) => {
            if (res.data.code === 0) {
              this.$refs.siruiTable.clearCheckboxReserve();
              this.getData();
              this.multipleSelection = [];
              this.idList = [];
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 查重
      handleCheck() {
        if (this.resolveSelected()) {
          this.$refs.check.openDialog(this.multipleSelection[0]);
        }
      },
      // 合并
      handleMerge() {
        if (this.resolveSelected()) {
          if (this.multipleSelection[0].requestStatus === 'ZT03') {
            // 已生效状态才可以有合并操作
            this.$refs.merge.openDialog(this.multipleSelection[0]);
          } else {
            this.$message({
              showClose: true,
              message: this.$t('cooperation.message.merge_need_enable'),
              type: 'error',
            });
          }
        }
      },
      refreshData() {
        console.log('1111111');
        this.getData();
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      setImport() {
        this.importUrl = API.IMPORT_PARTNER;
        this.importData = {
          tenantCode: this.userInfo.tenantCode,
          access_token: this.userInfo.access_token,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          lang: this.lang,
        };
      },
      // 批量导入
      handleImport() {
        // this.$refs.importBtn.$el.click();
        this.$refs.SiruiUpload.openDialog(true, '03');
      },
      // 开始上传
      uploadBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t('bank.message.importSuccess'),
            type: 'success',
          });
          this.getData();
        } else {
          this.$message({
            showClose: true,
            message: response.msg,
            type: 'error',
          });
          if (response.data) {
            window.location.href = response.data;
            this.getData();
          }
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
